/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createOperatorNode } from '../../factoriesNumber.js';
export var OperatorNodeDependencies = {
  NodeDependencies,
  createOperatorNode
};